.sidebar {
  background: var(--left-nav-element-background-default);
  width: 100px;
  height: 91%;
  position: fixed;
  bottom: 0;
  z-index: 200;
  border-right: 1px solid rgba(0, 0, 0, 0.12);

  .sidebar-item {
    background: var(--left-nav-element-background-default);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 80px;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    position: relative;

    &.active {
      background: var(--left-nav-element-background-selected);
      transition: all 0.2s ease-in-out;

      .icon,
      .text {
        color: var(--primary-main);
      }
    }

    .activeBar {
      width: 3px;
      height: 100%;
      background-color: var(--primary-main);
      position: absolute;
      top: 0;
      left: 0;
    }

    .icon {
      margin-bottom: 5px;
    }

    .text {
      margin: 0;
      font-size: 14px;
    }

    &:hover {
      background: var(--left-nav-element-background-hover);
      transition: all 0.2s ease-in-out;

      .icon,
      .text {
        color: var(--primary-main);
      }
    }
  }
}
